import { useEffect } from 'react'

import { t } from '../i18n'

/**
 * What the browser's tab, the window list and the history entry call this
 * screen.
 *
 * Every screen in this application had the same one: `SiteFocus: CM`, set once
 * in `index.html` and never touched again, because a single-page application
 * changes the screen without reloading the document. A trailer laptop with the
 * punch list, an RFI and the drawing set open in three tabs showed three tabs
 * with the same word on them, and the browser's own history read the same way.
 * It is also what a screen reader announces when a route changes, so a person
 * who cannot see the screen change was told nothing had.
 *
 * The parts are given most-specific first and joined with the product name
 * last, which is the order a truncated tab survives: a tab crops from the
 * right, so the word that tells two tabs apart has to be on the left.
 */
export function useDocumentTitle(...parts: (string | null | undefined)[]): void {
  const title = [...parts.filter((part): part is string => Boolean(part)), t('app.name')].join(
    ' · ',
  )
  useEffect(() => {
    document.title = title
  }, [title])
}
